export enum MissingChecklistsState {
  NONE = 'NONE',
  SEARCHING_MISSING_CHECKLISTS = 'SEARCHING_MISSING_CHECKLISTS',
  CHECKLISTS_CREATED = 'CHECKLISTS_CREATED',
  NO_MISSING_CHECKLISTS = 'NO_MISSING_CHECKLISTS',
  MISSING_CHECKLISTS = 'MISSING_CHECKLISTS',
  CREATING_CHECKLISTS = 'CREATING_CHECKLISTS',
  FAILED_TO_CREATE_CHECKLISTS = 'FAILED_TO_CREATE_CHECKLISTS',
}
